// src/DualListBox.js

import React, { useEffect, useState } from 'react';
import './DualListBox.scss'; // For SCSS styling
import { faSearch, faAngleLeft, faAnglesLeft, faAngleRight, faAnglesRight, faAnglesUp, faAngleUp, faAngleDown, faAnglesDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const DualListBox = (props) => {
  const { items, onChange, initialData } = props
  const [availableItems, setAvailableItems] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [availableSearch, setAvailableSearch] = useState('');
  const [selectedSearch, setSelectedSearch] = useState('');
  const [selectedAvailable, setSelectedAvailable] = useState(null);
  const [selectedSelected, setSelectedSelected] = useState(null);

  useEffect(() => {
    setAvailableItems(items?.length ? items : [])
  }, [items])

  useEffect(() => {
      setSelectedItems(initialData?.length ? initialData : [])
  }, [initialData])

  const moveToSelected = (e) => {
    e.preventDefault();
    if (selectedAvailable) {
      const item = availableItems.find(i => i.id === selectedAvailable);
      setAvailableItems(availableItems.filter(i => i.id !== selectedAvailable));
      onChange([...selectedItems, item])
      setSelectedItems([...selectedItems, item]);
      setSelectedAvailable(null);
    }
  };

  const moveToAvailable = (e) => {
    e.preventDefault();
    if (selectedSelected) {
      const item = selectedItems.find(i => i.id === selectedSelected);
      const data = selectedItems.filter(i => i.id !== selectedSelected)
      setSelectedItems(data);
      onChange(data)
      setAvailableItems([...availableItems, item]);
      setSelectedSelected(null);
    }
  };

  const moveAllToSelected = (e) => {
    e.preventDefault();
    setSelectedItems([...selectedItems, ...availableItems]);
    onChange([...selectedItems, ...availableItems])
    setAvailableItems([]);
  };

  const moveAllToAvailable = (e) => {
    e.preventDefault();
    setAvailableItems([...availableItems, ...selectedItems]);
    onChange([])
    setSelectedItems([]);
  };

  const moveUp = (e) => {
    e.preventDefault();
    const index = selectedItems.findIndex(i => i.id === selectedSelected);
    if (index > 0) {
      const newSelectedItems = [...selectedItems];
      [newSelectedItems[index], newSelectedItems[index - 1]] = [newSelectedItems[index - 1], newSelectedItems[index]];
      setSelectedItems(newSelectedItems);
      onChange(newSelectedItems)
    }
  };

  const moveDown = (e) => {
    e.preventDefault();
    const index = selectedItems.findIndex(i => i.id === selectedSelected);
    if (index < selectedItems.length - 1) {
      const newSelectedItems = [...selectedItems];
      [newSelectedItems[index], newSelectedItems[index + 1]] = [newSelectedItems[index + 1], newSelectedItems[index]];
      setSelectedItems(newSelectedItems);
      onChange(newSelectedItems)
    }
  };

  const moveToTop = (e) => {
    e.preventDefault();
    if (selectedSelected) {
      const item = selectedItems.find(i => i.id === selectedSelected);
      const data = [item, ...selectedItems.filter(i => i.id !== selectedSelected)]
      setSelectedItems(data);
      onChange(data)
    }
  };

  const moveToBottom = (e) => {
    e.preventDefault();
    if (selectedSelected) {
      const item = selectedItems.find(i => i.id === selectedSelected);
      const data = [...selectedItems.filter(i => i.id !== selectedSelected), item]
      setSelectedItems(data);
      onChange(data)
    }
  };

  const filteredAvailableItems
    = availableItems.filter(item =>
      item?.name?.toLowerCase().includes(availableSearch?.toLowerCase())
    );

  const filteredSelectedItems = selectedItems?.filter(item =>
    item?.name?.toLowerCase().includes(selectedSearch?.toLowerCase())
  );

  return (
    <div className="dual-list-box">
      <div className="list">
        <h3>{props?.listTitle}</h3>
        <div className='list-category'>
          <div className="search-input">
            <FontAwesomeIcon
              icon={faSearch}
              className="icon-magnifier mr-2"
            />
            <input
              type="text"
              placeholder="Search..."
              value={availableSearch}
              onChange={(e) => setAvailableSearch(e.target.value)}
            />
          </div>
          <ul>
            {filteredAvailableItems
              .map(item => (
                <li
                  key={item.id}
                  onClick={() => setSelectedAvailable(item.id)}
                  className={selectedAvailable === item.id ? 'selected' : ''}
                >
                  <img src={item.logo} alt={item.name} />
                  {item.name}
                </li>
              ))}
          </ul>
        </div>
      </div>

      <div className="arrows">
        <button onClick={moveAllToSelected}><FontAwesomeIcon icon={faAnglesRight} /></button>
        <button onClick={moveToSelected}><FontAwesomeIcon icon={faAngleRight} /></button>
        <button onClick={moveToAvailable}><FontAwesomeIcon icon={faAngleLeft} /></button>
        <button onClick={moveAllToAvailable}><FontAwesomeIcon icon={faAnglesLeft} /></button>
      </div>

      <div className="list">
        <h3>{props?.selectedListTitle}</h3>
        <div className='list-category'>
          <div className="search-input">
            <FontAwesomeIcon
              icon={faSearch}
              className="icon-magnifier mr-2"
            />
            <input
              type="text"
              placeholder="Search..."
              value={selectedSearch}
              onChange={(e) => setSelectedSearch(e.target.value)}
            />
          </div>
          <ul>
            {filteredSelectedItems?.map(item => (
              <li
                key={item?.id}
                onClick={() => setSelectedSelected(item.id)}
                className={selectedSelected === item.id ? 'selected' : ''}
              >
                <img src={item?.logo} alt={item?.name} />
                {item?.name}
              </li>
            ))}
          </ul>
        </div>
        {props?.selectedHotelServiceMaxLengthError?.length>0&&<p className='required'>{props?.selectedHotelServiceMaxLengthError}</p>}
      </div>

      <div className="rearrange-buttons">
        <button onClick={moveToTop}><FontAwesomeIcon icon={faAnglesUp} /></button>
        <button onClick={moveUp}><FontAwesomeIcon icon={faAngleUp} /></button>
        <button onClick={moveDown}><FontAwesomeIcon icon={faAngleDown} /></button>
        <button onClick={moveToBottom}><FontAwesomeIcon icon={faAnglesDown} /></button>
      </div>
    </div>
  );
};

export default DualListBox;
